import authenticationApi from '../api/budgetAuthenticationApi';
import localStorageProvider from '../utils/localStorageProvider';
import routePaths from '../routePaths';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import history from '../history';
import config from '../config';
import { failure, success } from './helpers';
import { handleNestedErrors } from '../utils/validation';
import { parseValidationErrors } from './backedValidationErrorsParser';

export const types = {
  BUDGET_SIGN_IN: 'BUDGET_SIGN_IN',
  BUDGET_SIGN_IN_SUCCESS: 'BUDGET_SIGN_IN_SUCCESS',
  BUDGET_SIGN_IN_FAILURE: 'BUDGET_SIGN_IN_FAILURE',
  BUDGET_SIGNED_OUT: 'BUDGET_SIGNED_OUT',
  BUDGET_CURRENT_USER_DATA: 'BUDGET_CURRENT_USER_DATA',
  BUDGET_CURRENT_USER_DATA_SUCCESS: 'BUDGET_CURRENT_USER_DATA_SUCCESS',
  BUDGET_CURRENT_USER_DATA_FAILURE: 'BUDGET_CURRENT_USER_DATA_FAILURE',
  BUDGET_ACCOUNT_ACTIVATION_SUBMIT: 'BUDGET_ACCOUNT_ACTIVATION_SUBMIT',
  BUDGET_ACCOUNT_ACTIVATION_SUCCESS: 'BUDGET_ACCOUNT_ACTIVATION_SUCCESS',
  BUDGET_ACCOUNT_ACTIVATION_FAILURE: 'BUDGET_ACCOUNT_ACTIVATION_FAILURE',
};

const authFailureReasons = Object.freeze({
  tokenExpired: 'tokenExpired',
});

export const actions = {
  signIn: (signInData, returnTo) => dispatch => {
    dispatch({ type: types.BUDGET_SIGN_IN });

    return authenticationApi
      .signIn(signInData)
      .then(authenticationResult => {
        if (authenticationResult.ok) {
          localStorageProvider.setItem(config.BUDGET_AUTH_STATE_ITEM_NAME, true);
          dispatch({ type: types.BUDGET_SIGN_IN_SUCCESS });
          dispatch(actions.getCurrentUserData());
          return history.push(returnTo || routePaths.myBudgetApplications);
        }

        dispatch({type: types.BUDGET_SIGN_IN_FAILURE});
        dispatch(notificationActions.showError('Logowanie nie powiodło się'));
        return logger.error(authenticationResult);
      });
  },
  register: (data) => dispatch => {
    return authenticationApi
      .register(data)
      .then(authenticationResult => {
        if (authenticationResult.ok) {
          dispatch(notificationActions.showSuccess('Konto zostało zarejestrowane'));
          return success();
        }

        dispatch(notificationActions.showError('Rejestracja nie powiodła się'));
        logger.error(authenticationResult);
        return failure(handleNestedErrors(parseValidationErrors(authenticationResult.data.validationErrors)));
      });
  },
  signOut: (returnTo) => dispatch => {
    localStorageProvider.removeItem(config.BUDGET_AUTH_STATE_ITEM_NAME);

    return authenticationApi
      .signOut()
      .then(result => {
        if (result.ok) {
          dispatch({ type: types.BUDGET_SIGNED_OUT });
          history.push(returnTo ? `${routePaths.budgetAuth.signIn}?returnTo=${returnTo}` : routePaths.budgetAuth.signIn);
        }
      });
  },
  activateAccount: activateAccountData => dispatch => {
    dispatch({ type: types.BUDGET_ACCOUNT_ACTIVATION_SUBMIT });

    return authenticationApi
      .activateAccount(activateAccountData)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.BUDGET_ACCOUNT_ACTIVATION_SUCCESS });
          dispatch(notificationActions.showSuccess('Konto zostało aktywowane'));
          return history.push(routePaths.budgetAuth.signIn);
        }

        if (response.status === 401 && response.data.failureReason === authFailureReasons.tokenExpired) {
          dispatch({ type: types.BUDGET_ACCOUNT_ACTIVATION_FAILURE });
          return dispatch(notificationActions.showError('Link aktywacyjny utracił ważność'));
        }

        dispatch({ type: types.BUDGET_ACCOUNT_ACTIVATION_FAILURE });
        dispatch(notificationActions.showError('Nie udało się aktywować konta'));
        return logger.error(response);
      });
  },
  recoverPassword: recoverPasswordData => dispatch => {
    return authenticationApi
      .recoverPassword(recoverPasswordData)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess('Link do resetu hasła został wysłany'));
          return history.push(routePaths.budgetAuth.signIn);
        } else {
          dispatch(notificationActions.showError('Nie udało się odzyskać hasła'));
          return logger.error(response);
        }
      });
  },
  resetPassword: resetPasswordData => dispatch => {
    return authenticationApi
      .resetPassword(resetPasswordData)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess('Hasło zostało zaktualizowane'));
          return history.push(routePaths.budgetAuth.signIn);
        }

        if (response.status === 401 && response.data.failureReason === authFailureReasons.tokenExpired) {
          return dispatch(notificationActions.showError('Link do resetu hasła utracił ważność'));
        }

        dispatch(notificationActions.showError('Nie udało się ustalić hasła'));
        return logger.error(response);
      });
  },
  getCurrentUserData: () => dispatch => {
    dispatch({ type: types.BUDGET_CURRENT_USER_DATA });
    return authenticationApi
      .me()
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.BUDGET_CURRENT_USER_DATA_SUCCESS, data: response.data });
        } else {
          dispatch({ type: types.BUDGET_CURRENT_USER_DATA_FAILURE });
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/budgetAuthActions.js